module.exports = __webpack_public_path__ + "static/grafika1-461bc7a38d7ed7aed1f6257ead6f2776.png";